"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchEventResultSaga = fetchEventResultSaga;
exports.fetchLinkedEventsSaga = fetchLinkedEventsSaga;
exports.fetchLinkedEvents = fetchLinkedEvents;
exports.resultProviderRootSaga = resultProviderRootSaga;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const effects_1 = require("redux-saga/effects");
const saga_1 = require("../ConfigProvider/saga");
const SportCountersProvider_1 = require("../SportCountersProvider");
const selectors_1 = require("../LanguagesProvider/selectors");
const ConfigProvider_1 = require("../ConfigProvider");
const saga_2 = require("../SportCountersProvider/saga");
const results_1 = require("../../api/results");
const errors_1 = require("../../utils/errors");
const constants_1 = require("../SportCountersProvider/constants");
const linkedEvents_1 = require("../../utils/events/linkedEvents");
const selectors_2 = require("./selectors");
const slice_1 = require("./slice");
const constants_2 = require("./constants");
/**
 * Helper funtion to create valid requst depends on feature flags
 * @param _request: GetEventResultsRequestV2
 * @returns
 */
function* buildRequest(_request) {
    const filters = yield (0, effects_1.select)(selectors_2.selectEventResultsListFilters);
    const config = yield (0, effects_1.select)(selectors_2.selectEventResultsListConfig);
    const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
    const includeSubsports = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
    const request = {
        locale,
        includeSubsports,
        pageKey: undefined,
        ...config,
        ...filters,
    };
    if (_request) {
        Object.assign(request, _request);
    }
    return request;
}
/**
 *  Конечная сага отвечающая за:
 *  1. получение данных и вызов коллбэков onError или onSuccess
 *  2. Изменение статуса fetchItems
 */
function* fetchEventResults(action) {
    const { reqData, sideEffects: { onError, onSuccess } = {}, params, } = action.payload;
    try {
        yield (0, effects_1.put)(slice_1.actions.fetchEventResults());
        const response = yield (0, effects_1.call)(results_1.getEventResultsV2, reqData);
        yield (0, effects_1.put)(slice_1.actions.updateEventResults({
            eventResults: response.data.items,
        }));
        yield (0, effects_1.put)(slice_1.actions.fetchEventResultsSuccess());
        if (onSuccess) {
            yield (0, effects_1.put)(onSuccess({ reqData, resData: response.data }));
        }
        const withLinkedEvents = params === null || params === void 0 ? void 0 : params.withLinkedEvents;
        const isLinkedEventsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.LINKED_EVENTS_ENABLED);
        if (isLinkedEventsEnabled && withLinkedEvents === true) {
            yield (0, effects_1.fork)(fetchLinkedEvents, response.data.items);
        }
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Error occurred while fetching event results', error);
        yield (0, effects_1.put)(slice_1.actions.fetchEventResultsError(error));
        if (onError) {
            yield (0, effects_1.put)(onError(error));
        }
    }
}
/**
 *
 * @param action PayloadAction<FetchEventResultsPayload | undefined>
 */
function* fetchEventResultsSaga(action) {
    var _a, _b, _c;
    const shouldUpdateCounters = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.shouldUpdateCounters;
    const withLinkedEvents = (_b = action.payload) === null || _b === void 0 ? void 0 : _b.withLinkedEvents;
    const isGenericSportsEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.GENERIC_SPORT_ENABLED);
    const request = yield (0, effects_1.call)(buildRequest, (_c = action.payload) === null || _c === void 0 ? void 0 : _c.reqData);
    if (shouldUpdateCounters) {
        yield (0, effects_1.call)(saga_2.fetchEventResultCountersSagaV2, SportCountersProvider_1.sportCountersProviderActions.fetchEventResultCounters({
            key: SportCountersProvider_1.ESportsCounterType.RESULTS,
            reqData: constants_1.DefaultCountersReq.RESULTS,
            aggregateByGeneric: isGenericSportsEnabled || undefined,
        }));
    }
    const sideEffects = {
        onSuccess: (payload) => slice_1.actions.fetchEventResultsListSuccess({ ...payload }),
        onError: (payload) => slice_1.actions.fetchEventResultsListError({ ...payload }),
    };
    yield (0, effects_1.call)(fetchEventResults, {
        payload: { reqData: request, sideEffects, params: { withLinkedEvents } },
        type: slice_1.actions.fetchEventResults.type,
    });
}
function* fetchEventResultsNextPageSaga(action) {
    var _a;
    yield (0, effects_1.put)(slice_1.actions.fetchEventResultsListNextStart());
    const request = yield (0, effects_1.call)(buildRequest, (_a = action.payload) === null || _a === void 0 ? void 0 : _a.reqData);
    const nextPageKey = yield (0, effects_1.select)(selectors_2.selectEventResultsNextPageKey);
    if (!nextPageKey)
        return;
    request.pageKey = nextPageKey;
    request.pageKeyDirection = betweb_openapi_axios_1.PaginationKeyDirection.Forward;
    const sideEffects = {
        onSuccess: (payload) => slice_1.actions.fetchEventResultsListNextSuccess({ ...payload }),
        onError: (payload) => slice_1.actions.fetchEventResultsListNextError({ ...payload }),
    };
    yield (0, effects_1.call)(fetchEventResults, {
        payload: { reqData: request, sideEffects },
        type: slice_1.actions.fetchEventResultsListNextPage.type,
    });
}
function* fetchEventResultSaga(action) {
    try {
        const { eventId } = action.payload;
        const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const response = yield (0, effects_1.call)(results_1.getEventResultsV2, {
            ids: [eventId],
            locale,
        });
        const { data: { items }, } = response;
        if (items.length === 0) {
            throw new Error('Event not found');
        }
        yield (0, effects_1.put)(slice_1.actions.fetchEventResultSuccess({ eventId }));
        yield (0, effects_1.put)(slice_1.actions.updateEventResults({ eventResults: items }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error("Couldn't fetch eventResult", error);
        const { eventId } = action.payload;
        yield (0, effects_1.put)(slice_1.actions.fetchEventResultError({ error, eventId }));
    }
}
function* fetchLinkedEventsSaga(action) {
    yield (0, effects_1.call)(fetchLinkedEvents, action.payload.events);
}
function* fetchLinkedEvents(events) {
    try {
        const ids = (0, linkedEvents_1.getLinkedEventsIds)(events);
        if (ids.length === 0) {
            return;
        }
        const locale = yield (0, effects_1.select)(selectors_1.selectCurrentLangCode);
        const requestPayload = {
            ids,
            locale,
            pageSize: constants_2.MIN_PAGE_SIZE,
        };
        const response = yield (0, effects_1.call)(results_1.getEventResultsV2, requestPayload);
        yield (0, effects_1.put)(slice_1.actions.fetchLinkedEventsSuccess({ events: response.data.items }));
    }
    catch (e) {
        const error = (0, errors_1.getErrorOrUnknown)(e);
        console.error('Couldnt fetch linked events for results', error);
    }
}
function* resultProviderRootSaga() {
    yield (0, effects_1.all)([
        (0, effects_1.takeLatest)(slice_1.actions.fetchEventResultsList.type, fetchEventResultsSaga),
        (0, effects_1.takeLatest)(slice_1.actions.fetchEventResultsListNextPage.type, fetchEventResultsNextPageSaga),
        (0, effects_1.takeLatest)(slice_1.actions.setFilters.type, fetchEventResultsSaga),
        (0, effects_1.takeLatest)(slice_1.actions.fetchEventResult.type, fetchEventResultSaga),
        (0, effects_1.takeLatest)(slice_1.actions.fetchLinkedEvents, fetchLinkedEventsSaga),
    ]);
}
//# sourceMappingURL=saga.js.map